module.exports = __webpack_public_path__ + "static/media/saaa.4fd9545f.jpg";